import { Label, TableRowDisplayEvent } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutOrderLoadTenderHistory } from "./autogen/AutogenLayoutOrderLoadTenderHistory";

export class OrderLoadTenderHistory extends AutogenLayoutOrderLoadTenderHistory {
    private _orderId: string;

    override onLoad(): void {
        this.mainDataSource.orderBy = [{ field: "create_date", sort: "desc" }];
    }

    tableTendersOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        if (modelRow != null) {
            const labelPartnerName = tableRow.findComponentById("labelPartnerName") as Label;
            labelPartnerName.quickInfoOverrideKeyValue = modelRow.get("id");
        }
    }

    set orderId(value: string) {
        this._orderId = value;
    }

    get orderId(): string {
        return this._orderId;
    }
}
